// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__GmYDJ","notes":"Notes_notes__ba-H6","note":"Notes_note__17l4d","markdown":"Notes_markdown__2_jm0"};